import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X, ArrowRight } from "lucide-react";

const KEY = "furn_opening_banner_dismissed";

export const AnnouncementBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(sessionStorage.getItem(KEY) !== "1");
  }, []);

  if (!show) return null;

  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setShow(false);
  };

  return (
    <div data-testid="opening-soon-banner" className="relative overflow-hidden bg-accent text-accent-foreground">
      <span className="banner-sheen" aria-hidden="true" />
      <div className="container-furn relative flex flex-col items-center justify-center gap-2 py-3 text-center sm:flex-row sm:gap-4 sm:py-3.5">
        <span className="flex items-center gap-2.5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-foreground opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-foreground" />
          </span>
          <Megaphone className="hidden h-5 w-5 shrink-0 sm:block" />
          <span className="font-display text-sm font-bold uppercase tracking-[0.18em] sm:text-base md:text-lg">
            Furn Angling is <span className="whitespace-nowrap">Opening Soon</span>
          </span>
        </span>
        <Link
          to="/contact"
          data-testid="banner-notify-link"
          className="group inline-flex items-center gap-1.5 rounded-full bg-accent-foreground px-4 py-1.5 text-[11px] font-bold uppercase tracking-widest text-accent transition-transform hover:scale-105 sm:text-xs"
        >
          Notify Me
          <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
      <button
        data-testid="banner-dismiss"
        onClick={dismiss}
        aria-label="Dismiss announcement"
        className="absolute right-3 top-3 rounded-sm p-1 transition-opacity hover:opacity-70 sm:top-1/2 sm:-translate-y-1/2"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
